import Configuration from '../configuration/Configuration';
import testConfiguration from '../configuration/default';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace NodeJS {
    interface ProcessEnv {
      CONFIGURATION: string;
    }
  }
}

const parsedConfiguration: Configuration = process.env.CONFIGURATION
  ? JSON.parse(process.env.CONFIGURATION)
  : testConfiguration;

if (!parsedConfiguration.contentful.spaceId) {
  console.error('CRITICAL: contentful.spaceId missing in configuration!', {
    hasEnvConfig: !!process.env.CONFIGURATION,
    deploymentEnv: process.env.DEPLOYMENT_ENV,
    configKeys: Object.keys(parsedConfiguration.contentful)
  });
} else {
  // Only log on server side to avoid cluttering browser console too much,
  // but helpful to see in Amplify logs.
  if (typeof window === 'undefined') {
    console.log('APP_CONFIG_LOADED:', {
      deploymentEnv: process.env.DEPLOYMENT_ENV,
      contentfulEnv: parsedConfiguration.contentful.environment,
      imtErpUrl: parsedConfiguration.imtErpUrl
    });
  }
}

export const configuration: Configuration = {
  ...parsedConfiguration
};
